export * from './AlarmResultViewModel';
export * from './DashboardReadResultDto';
export * from './DateValues';
export * from './ErrorDistribution';
export * from './ExecutedQueries';
export * from './GroupAlarmSummary';
export * from './InformationIdValue';
export * from './SerieIdWithVvmGuid';
export * from './SerieValue';
export * from './TextVariables';
export * from './WidgetQualityResult';
export * from './WidgetQueryResults';
export * from './WidgetReadResult';